import React from 'react';
import MessageCommon from 'src/common/message.common';

const ErrorPage = (): JSX.Element => {
    return <div>{MessageCommon.MESSAGE_ERROR_PAGE_ERROR}</div>;
};

export default React.memo(ErrorPage);
